import { Menu } from "@ark-ui/react";
import type { ComponentProps } from "react";

type Props = ComponentProps<typeof Menu.Item>;

const Item = ({ children, ...rest }: Props) => {
  return <Menu.Item {...rest}>{children}</Menu.Item>;
};

export default Item;
